import { useMemo, useContext, ReactNode } from 'react';
import { viewSettingsForTopic, TopicsWithFilters } from '../shared';
import { EntityContext } from 'context/entityContext';
import mapMetrics from 'maps/metrics';

/**
 * This hook determines the applicable view settings related to the provided topic.
 * The view settings are then mapped/transformed into a user-friendly readable message.
 */
export default function useViewSettingsNames(
  topic?: TopicsWithFilters
): Array<string | ReactNode> {
  const { viewSettings } = useContext(EntityContext);

  const validViewSettings = useMemo(() => {
    return topic ? viewSettingsForTopic[topic] || [] : [];
  }, [topic]);

  return useMemo(() => {
    return validViewSettings
      .map((item: string) => {
        switch (item) {
          case 'timeframe': {
            return viewSettings?.timeframe
              ? mapMetrics[viewSettings.timeframe]?.label
              : '';
          }
          default:
            return '';
        }
      })
      .filter((v) => v !== '');
  }, [validViewSettings, viewSettings]);
}
